import { combineReducers } from '@reduxjs/toolkit';

import { aggregateReducer, cartReducer, sharedReducer } from 'store/audience-builder/slices';

const rootReducer = combineReducers({
  aggregate: aggregateReducer,
  cart: cartReducer,
  shared: sharedReducer,
});

export const audienceReducer = rootReducer;
